<template>
  <div class="card-body px-2 bd-b py-3" v-if="!isEmpty(scientificAwards)">
    <h3 class="mb-3 t-500 px-3">
      Scientific Awards <span class="t-secondary">{{ scientificAwards.length }}</span>
      <i class="fa fa-trophy d-block pull-right t-placeholder"></i>
    </h3>
    <!-- Collapsed view, only show first award -->
    <template v-if="scientificAwards.length > 1 && collapsed">
      <award :award="scientificAwards[0]" />
    </template>
    <!-- Show everything/uncollapsed -->
    <template v-else>
      <award v-for="(award, index) in scientificAwards" :key="index" :award="award" />
    </template>

    <a
      v-if="scientificAwards.length > 1"
      @click.prevent="collapsed = !collapsed"
      class="px-3 t-sm mt-2"
      href="#"
    >Show {{ collapsed ? 'all' : 'less' }}</a>
  </div>
</template>

<script>
import Award from '@/components/shared/scientificAwards/Award'

export default {
  name: 'scientificAwardsResearcher',
  props: {
    awards: {
      type: Array,
      required: true
    }
  },
  components: {
    Award
  },
  data () {
    return {
      collapsed: true
    }
  },
  computed: {
    scientificAwards () {
      return this.awards.filter(award => {
        return award.name
      })
    }
  }
}
</script>
